import React from 'react';
import PropTypes from 'prop-types';
import SearchAdapter from './SearchAdapter';
const SearchContext = /*#__PURE__*/React.createContext();
class SearchContextProvider extends React.PureComponent {
  constructor(props) {
    super(props);
    const {
      shouldSearchOnChange,
      shouldSubscribeToStateChange,
      shouldSubscribeToResultChange,
      shouldSubscribeToResultError,
      shouldSearchOnMount,
      children,
      ...searchAdapterOptions
    } = props;
    this.searchAdapter = props.searchAdapter || new SearchAdapter(searchAdapterOptions);
    this.state = {
      searchState: this.searchAdapter.getState(),
      searchResult: this.searchAdapter.getResult() || {},
      searchError: null
    };
  }
  componentDidMount() {
    this.subscribeToSearchAdapter();
    if (this.props.shouldSearchOnMount) {
      this.searchAdapter.search();
    }
  }
  subscribeToSearchAdapter() {
    const {
      shouldSubscribeToStateChange,
      shouldSubscribeToResultChange,
      shouldSubscribeToResultError
    } = this.props;
    if (shouldSubscribeToStateChange) {
      this.searchAdapter.subscribe('change', () => this.setState({
        searchState: this.searchAdapter.getState()
      }));
    }
    if (shouldSubscribeToResultChange) {
      this.searchAdapter.subscribe('result', searchParamsAndResult => {
        this.setState({
          searchResult: searchParamsAndResult
        });
      });
    }
    if (shouldSubscribeToResultError) {
      this.searchAdapter.subscribe('error', error => this.setState({
        searchError: error
      }));
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(SearchContext.Provider, {
      value: {
        searchAdapter: this.searchAdapter,
        ...this.state
      }
    }, this.props.children);
  }
}
SearchContextProvider.defaultProps = {
  searchAdapter: undefined,
  initialState: {},
  stateManager: null,
  shouldSearchOnChange: false,
  shouldSubscribeToStateChange: false,
  shouldSubscribeToResultChange: true,
  shouldSubscribeToResultError: true,
  shouldSearchOnMount: false
};
SearchContextProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  searchAdapter: PropTypes.shape(),
  algoliaAPIKey: PropTypes.string.isRequired,
  algoliaAppName: PropTypes.string.isRequired,
  initialState: PropTypes.shape(),
  stateManager: PropTypes.shape(),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  shouldSearchOnChange: PropTypes.bool,
  shouldSubscribeToStateChange: PropTypes.bool,
  shouldSubscribeToResultChange: PropTypes.bool,
  shouldSubscribeToResultError: PropTypes.bool,
  shouldSearchOnMount: PropTypes.bool
} : {};
export const SearchProvider = SearchContextProvider;
export const SearchConsumer = SearchContext.Consumer;